<template lang='pug'>
.review
	viewer(
		v-if='location && location.lat && location.lng'
		:pin='location'
		:location='location'
	)
	.review-info
		.title
			h1 FID Review - {{ review.referenceNumber }}

		p.sub-title Response by {{ review.responseBy }}
		p.sub-title Response date {{ formatDate( review.dateResponse ) }}
		.expand-info(@click='setExpandState')
			p Expand all Info
			.clickable-arrow(:class='expandState')

		.info
			list-layout(
				:layout='listItems'
				:parentObj='review'
				:class='{ "slide-in" : expandState === "open" }'
			)
</template>

<script>
import ListLayout from '@/components/ListLayout';
import Viewer from '@/components/map/Viewer';
import DocumentList from '@/components/DocumentList';

// eslint-disable-next-line no-unused-vars
import Submit from '@/lib/Submit';
import { objectOrNull } from '@/lib/vue-validators';
import { FormatDate } from '@/lib/utils';

export default {
	name : 'review',

	props : {
		review : {
			required  : true,
			validator : objectOrNull,
		}
	},

	data : () => ( {
		expandState      : 'close',
		documentsShowing : 'closed',
	} ),

	computed : {

		formattedReview() {

			const { review } = this;
			const {
				dateDeadline,
				dateReceived,
				dateResponse,
				...otherProps
			} = review;

			const dates = {
				dateDeadline,
				dateReceived,
				dateResponse,
			};

			const formattedDates = Object.keys( dates ).reduce( ( obj, key ) => {
				const date = dates[key];
				const added = {};

				added[key] = FormatDate( new Date( date ), 'MMMM D, YYYY', 'GMT' );

				return {
					...obj,
					...added,
				};
			}, {} );

			return {
				...formattedDates,
				...otherProps,
			};

		},

		listItems() {
			return {
				items : {
					facilities : {
						items : {
							name : 'Facilities'
						}
					},
					reviewsTypes : {
						items : {
							description : 'Review Types',
						},
					},
					referenceNumber : 'Reference #',
					firm            : {
						items : {
							description : 'Agency/Engineer',
						},
					},
					comments : 'Comments',
					dates    : {
						title  : 'Dates',
						parent : this.review,
						items  : {
							dateDeadline : 'Deadline Date',
							dateReceived : 'Date Received',
							dateResponse : 'Response Date',
							responseBy   : 'Response By',
						}
					},
					location : {
						title  : 'Location',
						parent : this.review,
						items  : {
							apn      : 'APN #',
							location : {
								items : {
									description : 'Cross Streets',
								},
							},
						}
					}
				}
			};
		},

		location() {
			const { location } = this.review;

			if ( !location || !Object.keys( location || {} ).length ) {
				return null;
			}

			return {
				lat : location.latitude,
				lng : location.longitude,
			};
		},

	},

	methods : {

		toggleDocumentsShowing() {

			this.expandState = 'close';

			if ( this.documentsShowing === 'opened' ) {
				this.documentsShowing = 'closed';
				return;
			}

			this.documentsShowing = 'opened';

		},

		setExpandState() {
			this.documentsShowing = 'closed';

			const { expandState } = this;
			this.expandState = expandState === 'open' ? 'close' : 'open';
		},

		formatDate( date ) {
			return FormatDate( date, 'MMMM D, YYYY', 'GMT' );
		},

	},

	components : {
		ListLayout,
		Viewer,
		DocumentList,
	},
};
</script>

<style lang='scss'>

.review {
	width: 100%;

	.viewer {
		border-radius: 0;

		+ .review-info {
			margin-top: 30px;
		}
	}

	.review-info {
		display: flex;
		flex-flow: column;
		padding: 0 30px 20px 30px;
		width: 100%;

		.sub-title {
			font-weight: 600;
		}

		.title {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;

			p {
				font-size: 32px;
				font-weight: 600;
			}
		}

		.expand-info {
			margin-left: 0;
		}

		.document-list {
			position: relative;
			padding: 15px 30px 0px 30px;
			width: 100%;
			left: 0;
			opacity: 1;
			transform: translateY(0);
			pointer-events: all;
			z-index: 1;
			max-height: 1000px;
			transition: max-height .2s ease-in, transform .2s ease-in, opacity .2s ease-in;

			&.closed {
				opacity: 0;
				transform: translateY(-100%);
				padding: 0 30px;
				z-index: -1;
				max-height: 0;
				pointer-events: none;
			}
		}

		.list-layout {

			.sub-title {
				font-weight: normal;
			}

			.list-item.item-reviewsType {
				flex: 2 2 48%;
			}
		}
	}
}

</style>
